/* Inner Page Nav — index-based tab/panel pairing.
 *
 * Pairing rule: tabs and panels inside the same [data-inner-nav] scope pair by their DOM order.
 * Tab N shows Panel N. No IDs needed.
 *
 * On init:
 *   - Mark each scope with [data-nav-ready] (flips CSS from :first-of-type fallback to .is-active mode)
 *   - Find the tab with [data-nav-active] (user's "Active by default" checkbox). If none, use tab 0.
 *   - Activate that index (highlight tab, show matching panel, hide others).
 *
 * On click: find the clicked tab's index within its scope and activate that index.
 */
(function () {
  'use strict';
  if (window.__innerNavBound) return;
  window.__innerNavBound = true;

  function scopeOf(el) {
    return el.closest('[data-inner-nav]');
  }

  function tabsOf(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('[data-nav-tab]'));
  }

  function panelsOf(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('[data-nav-panel]'));
  }

  function activate(scope, index) {
    if (!scope) return;
    var tabs = tabsOf(scope);
    var panels = panelsOf(scope);
    if (index < 0) index = 0;
    if (index >= tabs.length) index = tabs.length - 1;

    tabs.forEach(function (tab, i) {
      var on = i === index;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panels.forEach(function (panel, i) {
      var on = i === index;
      panel.classList.toggle('is-active', on);
    });
  }

  function onClick(e) {
    var tab = e.target.closest('[data-nav-tab]');
    if (!tab) return;
    var scope = scopeOf(tab);
    if (!scope) return;
    var tabs = tabsOf(scope);
    var index = tabs.indexOf(tab);
    if (index < 0) return;
    e.preventDefault();
    activate(scope, index);
  }

  function initScope(scope) {
    if (!scope) return;
    var tabs = tabsOf(scope);
    if (tabs.length === 0) return;
    // Find the tab marked Active by default, else default to 0
    var initialIndex = 0;
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].hasAttribute('data-nav-active')) { initialIndex = i; break; }
    }
    scope.setAttribute('data-nav-ready', '');
    activate(scope, initialIndex);
  }

  function init() {
    document.querySelectorAll('[data-inner-nav]').forEach(initScope);
    document.addEventListener('click', onClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders sections; re-init when a new one lands
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-inner-nav]').forEach(initScope);
    var self = e.target.matches && e.target.matches('[data-inner-nav]') ? e.target : null;
    if (self) initScope(self);
  });

  // When editing a block, activate its containing panel so Dror sees what he's editing
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (!el) return;
    var scope = scopeOf(el);
    if (!scope) return;

    // If it's a tab (or a block inside a tab), activate that tab's index
    var tab = el.matches('[data-nav-tab]') ? el : el.closest('[data-nav-tab]');
    if (tab) {
      var tabIdx = tabsOf(scope).indexOf(tab);
      if (tabIdx >= 0) activate(scope, tabIdx);
      return;
    }

    // If it's a panel (or a block inside a panel), activate that panel's index
    var panel = el.matches('[data-nav-panel]') ? el : el.closest('[data-nav-panel]');
    if (panel) {
      var pIdx = panelsOf(scope).indexOf(panel);
      if (pIdx >= 0) activate(scope, pIdx);
    }
  });
})();
